var _defs, _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshPasswordIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".refreshPasswordIco_svg__a{fill:none}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "refreshPasswordIco_svg__a",
    width: 20,
    height: 20,
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "refreshPasswordIco_svg__a",
    d: "M6.73 8.444h4.484v3.604H6.73zM9.882 6.693v-.588a.929.929 0 10-1.858 0v.588z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.133 8.938a7.214 7.214 0 11-2.357-5.309l-2.17 2.17a2.672 2.672 0 00-5.327.306v.656a1.747 1.747 0 00-1.293 1.682v3.6a1.752 1.752 0 001.75 1.75h4.477a1.752 1.752 0 001.75-1.75v-3.6a1.749 1.749 0 00-1.33-1.693v-.644c0-.045-.011-.087-.013-.13h5.553V.228l-2.166 2.165a8.926 8.926 0 102.871 6.545zm-7.18-3.762a.93.93 0 01.928.929v.588H8.024v-.587a.93.93 0 01.929-.93zm-2.22 6.872v-3.6h4.48v3.6z"
  })));
}
export default SvgRefreshPasswordIco;